import { useI18n } from 'builder/hooks/useI18n'
import { TRANSLATION } from '../constants'
import * as Styles from './styles'

export const QuestionnaireInfo = () => {
  const { i18n } = useI18n()

  return (
    <Styles.InfoSection>
      <Styles.InfoSectionIcon />
      <Styles.InfoSectionDescription>
        {i18n.t(`${TRANSLATION}.time`)}
        <Styles.InfoSectionDescriptionBold>
          {i18n.t(`${TRANSLATION}.time_minutes`)}
        </Styles.InfoSectionDescriptionBold>
      </Styles.InfoSectionDescription>
    </Styles.InfoSection>
  )
}
